import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { ProductPosition } from "shared/types/ProductPosition"

import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useProductPositionActionHandlers } from "features/product-position-management/model/useProductPositionActionHandlers"

import { ProductPositionsActionsOverlayViewModel } from "../ProductPositionActionsOverlayView"

export function useProductPositionActionsOverlayViewModel(
  projectID: string,
  productPosition: ProductPosition
): ProductPositionsActionsOverlayViewModel {
  const { closeOverlay } = useCurrentOverlay()
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useProductPositionActionHandlers({
    projectID,
    productPosition,
    permissions: permissions ?? readonlyProjectPermissions,
    onAction: closeOverlay
  })

  return {
    ...handlers,
    onClose: closeOverlay
  }
}
